import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
/** Components */
import { AppComponent } from './app.component';

import { TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule } from '@angular/common/http'; // HttpModule
import { HttpClient } from '@angular/common/http'; // Http
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { Media } from '@ionic-native/media/ngx';
import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2/ngx';
import { ReactiveFormsModule } from '@angular/forms';
import { LoaderComponent } from './components/loader/loader.component';
import { QrscannerModule } from './utils/services/qrscanner/qrscanner.module';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';

export const createTranslateLoader = (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json');

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [ReactiveFormsModule, QrscannerModule, BrowserModule, IonicModule.forRoot(),
    AppRoutingModule, HttpClientModule, TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, ScreenOrientation, Media, InAppPurchase2,
    LoaderComponent, FileTransfer, File],
  bootstrap: [AppComponent],
})
export class AppModule { }
